import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTable, MatTableDataSource } from '@angular/material';
import { saveAs } from 'file-saver';
import { PessoaService } from '../../../../../../services/grl/pessoa.service';



export interface PeriodicElement {
  nome: string;
  endereco: string;
  dtAtivacao: string;
  dtInativacao: string;
  validadeCnh: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {
    nome: ' ',
    endereco: ' ',
    dtAtivacao: ' ',
    dtInativacao: ' ',
    validadeCnh: ' '
  }
];

@Component({
  selector: 'grid-documentos',
  templateUrl: './grid-documentos.component.html',
  styleUrls: ['./grid-documentos.component.scss']
})
export class GridDocumentosComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatTable, { static: true }) dataTable: MatTable<any>;

  displayedColumns: string[] = ['dtArquivamento', 'dtVencimento', 'nmDocumento', 'download'];
  pageSize: number = 10;
  dataSource: MatTableDataSource<any>;
  arquivos = []

  constructor(
    private _pessoaService: PessoaService
  ) {

  }

  ngOnInit() {
  }

  async load(cdPessoa){
    this._pessoaService.getArquivos(cdPessoa).then( result =>{
      this.dataSource = new MatTableDataSource(result);

      this.dataSource.filterPredicate = (data: any, filter: string) => 
      data.nmDocumento.toLowerCase().indexOf(filter.trim().toLowerCase()) != -1

      this.dataSource.paginator = this.paginator;
    })
  }

  download(item){
    const file = new Blob([new Uint8Array(item.blbArquivo)], {type: 'application/octet-binary'});
    saveAs(file, item.nmArquivo);
  } 

  applyFilter(filterValue: string) {
    console.log(filterValue)
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }



}
